export const DELETE_TEMPORARY_ITEM = 'DELETE_TEMPORARY_ITEM';

export const deleteTemporaryItem = context => ({
  type: DELETE_TEMPORARY_ITEM,
  context,
});
